import React, { useEffect, useState } from "react";
//import zoomSdk from "@zoom/appssdk";
import * as microsoftTeams from "@microsoft/teams-js";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import CryptoJS from "crypto-js";
import { API_BASE_URL, APP_BASE_URL, CONNECT_BASE_URL, SALT_KEY } from "../utility/constants";
import AlertMsg from "./Alert";
import FooterSecuredBy from "./footerSecuredBy";
// import {  msalInstance } from "../utility/msalConfig";
import { isMacOS } from "../utility/util";
import { useMsal } from "@azure/msal-react";
//import InviteMobileModal from "./InviteMobileModal";




const PublishForm = (props) => {
  const [formpublished, setFormPublished] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [invitationerror, setInvitationError] = useState(false);
  const [isInvitationopen, setInvitationOpen] = useState(false);
  const [waitforform, setWaitForForm] = useState(false);
 const GRAPH_SCOPES = ["Chat.ReadWrite", "ChatMessage.Send"];

  const recordindex = useSelector(
    (state) => state?.donation?.useraccountinfo || {}
  );
const teamsuserData = useSelector((state) => state?.donation?.teamsData || []);
// const GiventID = useSelector((state) => state?.donation?.giventID || 0);
  const formSettings = useSelector(
    (state) => state?.donation?.formSettings || {}
  );
   const theme = useSelector((state) => state?.donation?.theme || "");

  const navigate = useNavigate();
 
  const { instance, inProgress } = useMsal();

  const publish = async (e) => {
    e.preventDefault();
    setShowLoader(true);
   // setInvitationOpen(true);
    let publishData = {
      eId: props.userData.meetingId ? props.userData.meetingId : sessionStorage.getItem("MID"),
      Id: recordindex.recordId,
    };
   
    let postBody = CryptoJS.AES.encrypt(
      JSON.stringify({ body: { publishData } }),
      SALT_KEY
    ).toString();
    axios
      .post(`${API_BASE_URL}`, {
        httpMethod: "POST",
        path: "/publishform",
        postBody,
      })
      .then((res) => {
        if (res.data.body) {
            setInvitationOpen(true);
            setShowLoader(false);
        }
      })
      .catch((err) => {
  
        if(err.toString().indexOf('denied') > -1){
          setFormPublished(true);
          navigate("/loadform", { state: { showDForm: true } });
          setShowLoader(false);
          setInvitationOpen(false);
        }else{
          setFormPublished(true);
          setInvitationError(true);
          setShowLoader(false);
          setInvitationOpen(false);
        }
       
        
      });
  };

  const reLoad = () => {
    navigate('/loadform', { state: { showDForm: true } })
  }
  

  useEffect(()=>{
     if(isInvitationopen){

       if(props.appcontext !== "web" && props.appcontext !== "desktop"){
              navigate('/minvite');
       }else{

           let urlDialogInfo = {
                      title: null,
                      height: null,
                      width: null,
                      url: null,
                      fallbackUrl: null,
                  };
                  
                  urlDialogInfo.url = `${APP_BASE_URL}/invite`;
                  urlDialogInfo.height = 400;
                  urlDialogInfo.width = 800;
                  
              
                   microsoftTeams.dialog.url.open(urlDialogInfo,  (submitHandler) => {
                    
                    if(submitHandler.result && submitHandler.result.message){
                      if(submitHandler.result.message === "allow"){
                      
                          setWaitForForm(true);
                          login(props.chatId, props.userData.meetingId);
                      }
                      if(submitHandler.result.message === "deny"){
                       
                        setInvitationOpen(false);
                        setFormPublished(true);
                        navigate("/loadform",{ state: { showDForm: true } });
                        setShowLoader(false);
                        setWaitForForm(false);
                      }
                      
                    }
                    if(submitHandler.err){
                      console.log(`Submit handler - err:`,submitHandler.err);
                    }
                      
                     
                  });
               
                }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isInvitationopen]);

 

  const login = async (chatId, mId) => {
    try {
  
      
       let token = await getGraphToken(teamsuserData.email);
       const context = {
          subEntityId: "",
          chatId: props.chatId,
        };
      
        const deeplink = `https://teams.microsoft.com/l/entity/2d4b2d47-2011-4b9e-b789-dbacff73382e/givent?context=${encodeURIComponent(JSON.stringify(context))}`;

      if(token) await sendMessage(chatId, deeplink, token)
    } catch (error) {
       setInvitationError(true);
    }
  };




const getGraphToken = async (userEmail) => {
  await microsoftTeams.app.initialize();

  const context = await microsoftTeams.app.getContext();
  const loginHintFromTeams = context?.user?.loginHint || context?.user?.userPrincipalName;
  const loginHint = loginHintFromTeams || userEmail;

  try {
    if (inProgress !== "none") {
      await waitForInteractionToComplete(instance, 5000);
    }

    const isMacOs = isMacOS();

    if (isMacOs) {
      instance.clearCache();
      return handleTeamsDesktopAuth(loginHint);
    }

    // 1) Try silent using any existing account first (no loginHint)
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      try {
        const silentToken = await instance.acquireTokenSilent({
          scopes: GRAPH_SCOPES,
          account: accounts[0],
        });
        return silentToken.accessToken;
      } catch (e) {
        console.warn("Silent with account failed, will try loginHint/popup", e);
      }
    }

    // 2) Try silent with loginHint
    try {
      const silentTokenWithHint = await instance.ssoSilent({
        scopes: GRAPH_SCOPES,
        loginHint,
      });
      return silentTokenWithHint.accessToken;
    } catch (silentError) {
      console.warn("Silent SSO failed, trying popup", silentError);
    }

    // 3) Popup – let user pick the right account/tenant
    const popupToken = await instance.acquireTokenPopup({
      scopes: GRAPH_SCOPES,
      // you can *omit* loginHint here to let them choose the right account
      // loginHint,
    });

    return popupToken.accessToken;

  } catch (error) {
    console.error("Auth completely failed:", error);
    instance.clearCache();
    throw error;
  }
};


 const handleTeamsDesktopAuth = async (loginHint) => {
  try {
    const authResult = await microsoftTeams.authentication.authenticate({
      url: `${window.location.origin}/auth?teamsAuth=true&loginHint=${encodeURIComponent(loginHint || "")}`,
      width: 600,
      height: 600,
    });

    if (authResult.startsWith("ey")) {
      return authResult; // raw token from your auth page
    }

    const response = await instance.acquireTokenByCode({
      code: authResult,
      scopes: GRAPH_SCOPES,
      redirectUri: `${window.location.origin}/auth`,
    });

    return response.accessToken;
  } catch (error) {
    console.error("Teams desktop auth failed:", error);
    throw error;
  }
};

  // Helper function to wait for ongoing interaction to complete
const waitForInteractionToComplete = async (instance, timeout) => {
  const start = Date.now();
  while (instance.getAllAccounts().length === 0 && Date.now() - start < timeout) {
    await new Promise(resolve => setTimeout(resolve, 100));
  }
};
 
  const sendMessage = async (chatId, tabsAppDeepLink, accessToken) => {
    try {

      const response = await fetch(
        `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        
          body: JSON.stringify({
            body: {
              content: `Hello <at id="0">everyone</at>! <attachment id="1"></attachment>`, // Fallback text if Adaptive Cards are not supported
              contentType: "html", // Use "html" to support rich formatting
            },
            mentions: [
              {
                id: 0,
                mentionText: "everyone",
                mentioned: {
                  conversation: { id: chatId },
                },
              }
            ],
            importance: "urgent",
            attachments: [
              {
                id:"1",
                contentType: "application/vnd.microsoft.card.adaptive",
                content: JSON.stringify({
                  type: "AdaptiveCard",
                  version: "1.4",
                  body: [
                    // {
                    //   type: "TextBlock",
                    //   text: "Your Donation form has been published, Please Click on Givent tab added in the meeting to start your donation.",
                    //   wrap: true,
                    // },
                    {
                    type: "TextBlock",
                    text: "🎉 Your donation form is ready!",
                    wrap: true,
                    weight: "Bolder",
                    size: "Large"
                  },
                  {
                    type: "TextBlock",
                    text: "Go to your meeting and click on the **Givent tab** (in the meeting tabs/content bar) from the top bar to start your donation.",
                    wrap: true,
                    spacing: "Medium"
                  },
                  {
                    type: "TextBlock",
                    text: "Donations are not supported inside the Teams mobile app. Tap below to continue in your browser.",
                    wrap: true
                  }
                  ],
                  actions: [
                    {
                      type: "Action.OpenUrl",
                      title: "Givent",
                      url : `${CONNECT_BASE_URL}/${recordindex.formGUID}`
                     // url: `${PAYQUICKLY_BASE_URL}?guid=${recordindex.formGUID}&giventId=${GiventID}&eventId=${props.userData.meetingId}&trk=${formSettings.Tracker}&sku=${formSettings.GiventSKU}&fheader=${formSettings.FormHeader}`, // Your deep link here
                    },
                  ],
                }),
              },
            ],
          }),
        }
      );

      if (response.ok) {
        setInvitationOpen(false);
        setFormPublished(true);
        setWaitForForm(false);
        navigate("/loadform",{ state: { showDForm: true } });
        setShowLoader(false);
        localStorage.removeItem('chatId'); // Clear chatId after use
      } else {
        const error = await response.json();
        console.error("Error sending message:", error);
      }
    } catch (error) {
      console.error("Error acquiring token or sending message:", error);
    }
  };
 
  return (
    <>
      <div className={"recurring_transaction_container " + (theme || "")}>
        <div className="recurring_transaction_wrapper">
          <div className={"recurring_transaction_card mt_2 " + (theme || "")}>
            <div className="recurring_transaction_card_header">
              <div className="transaction_info_logo_container">
             
                {!formSettings.FormHeader ? (
                        <img src={`images/givent_logo_1.png?${(new Date()).getTime()}`} alt="Click and Pledge" />
                      ):(
                        <div className="header-name">{formSettings.FormHeader}</div>
                      )}
              </div>

              {formpublished && !invitationerror && (
                <AlertMsg
                  message="Form Published Successfully! Please wait your form is loading..."
                  type="success"
                  isClose={false}
                />
              )}
              {invitationerror && (
                <>
                 <AlertMsg
                 message="Send Invitation timeout! Please reload your app again."
                 type="failure"
                 isClose={true}
               />
               <p onClick={reLoad} style={{color:'blue', cursor:'pointer'}}>Reload</p>
               </>
              )}
              {showLoader && (
                <div className="loader-container">
                 <div className="lds-ellipsis">
                 <div></div>
                 <div></div>
                 <div></div>
                 <div></div>
               </div>
               </div>
              )}
           
            </div>
            <div className="recurring_transaction_card_body">
            
              <div className="form_input_wrapper d-flex justify-content-between mt_1">
                <button
                  className="full_button tabindex_btn next"
                  type="button"
                  data-index="0"
                  onClick={publish}
                  disabled={formpublished || showLoader || waitforform}
                  style={{marginBottom:'20px'}}
                >
                  {!showLoader && !waitforform ? (
                    <>
                      <span className="">Publish & Broadcast</span>
                    </>
                  ) : (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span className="">Loading...</span>{" "}
                    </>
                  )}
                </button>
              </div>
              {/* {error1 && (
                <AlertMsg
                  message={"Error1: " + error1}
                  type="failure"
                  isClose={true}
                  onClose={() => setError1("")}
                />
              )} */}
              {/* {error2 && (
                <AlertMsg
                  message={"Error2: " + error2}
                  type="failure"
                  isClose={true}
                  onClose={() => setError2("")}
                />
              )} */}
              
              {/* {error3 && (
                <AlertMsg
                  message={"Error3: " + error3}
                  type="failure"
                  isClose={true}
                  onClose={() => setError3("")}
                />
              )} */}
              {/* {isObocalled && "IsOBO: " + isObocalled} */}
              {/* {teamsToken && "Teams Token: " + teamsToken} */}

            </div>
            <FooterSecuredBy />
          </div>
        </div>
      </div>
    </>
  );
};

export default PublishForm;
